import { render } from "./quizAnswer.vue?vue&type=template&id=6e9b4be5&scoped=true"
import script from "./quizAnswer.vue?vue&type=script&lang=js"
export * from "./quizAnswer.vue?vue&type=script&lang=js"

import "./quizAnswer.vue?vue&type=style&index=0&id=6e9b4be5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9b4be5"]])

export default __exports__